import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetFileManager } from './useGetFileManager'
import { FileManagerContent } from './FileManagerContent'

export const FileManagerComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetFileManager(id, tileFilterSelections)

  return (
    <FileManagerContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function FileManagerComponentLoading() {
  return 'Loading...'
}
